import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-class-ended',
  templateUrl: './class-ended.component.html',
  styleUrls: ['./class-ended.component.css']
})
export class ClassEndedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.close();

  // If close() didn't work (window wasn't script-opened), give the user something to do
  setTimeout(() => {
    document.body.innerHTML = '<p>You May Now Safely Close This Window.</p>';
  }, 300);
  }

}
